import { render, staticRenderFns } from "./GenericJournals.vue?vue&type=template&id=ca2e56aa"
import script from "./GenericJournals.vue?vue&type=script&lang=js"
export * from "./GenericJournals.vue?vue&type=script&lang=js"
import style0 from "./GenericJournals.vue?vue&type=style&index=0&id=ca2e56aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports